module.exports = __webpack_public_path__ + "static/meteor-swarm-mtg_afr-7a31719686ea8f86dbbf0a0234513aff.jpg";